<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CRow>
            <CCol sm="3">
              <CInput
                label="User Code"
                invalid-feedback="Name should be filled"
                readonly
                v-model="$v.usersForm.user_code.$model"
                :is-valid="!$v.usersForm.user_code.$invalid"
              />
            </CCol>
            <CCol sm="6">
              <CInput
                label="Unique Code"
                invalid-feedback="Name should be filled"
                readonly
                v-model="$v.usersForm.uuid.$model"
                :is-valid="!$v.usersForm.uuid.$invalid"
              />
            </CCol>
            <CCol sm="3">
              <CInput
                label="Nama User"
                invalid-feedback="Name should be filled"
                required
                v-model="$v.usersForm.name.$model"
                :is-valid="!$v.usersForm.name.$invalid"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="3">
              <CInput
                label="Email"
                invalid-feedback="Email should be filled"
                required
                v-model="$v.usersForm.email.$model"
                :is-valid="!$v.usersForm.email.$invalid"
              />
            </CCol>

            <CCol sm="3">
              <CInput
                label="Handphone"
                invalid-feedback="Handphone should be filled"
                required
                v-model="$v.usersForm.mobile_phone.$model"
                :is-valid="!$v.usersForm.mobile_phone.$invalid"
              />
            </CCol>

            <CCol sm="3">
              <CInput
                type="number"
                label="Point"
                invalid-feedback="Points should be filled"
                v-model="$v.usersForm.points.$model"
                :is-valid="!$v.usersForm.points.$invalid"
              />
            </CCol>
          </CRow>
          <CRow>
            <!-- <CCol sm="3">
              <CSelect
                label="Status"
                invalid-feedback="Status should be selected"
                :options="listStatusCustomer"
                required
                placeholder="Please Select one"
                :value.sync="$v.usersForm.status.$model"
                :is-valid="!$v.usersForm.status.$invalid"
              />
            </CCol> -->
            <CCol sm="3">
              <div class="form-group">
                <label for="status">Status</label>
                <model-select
                  class="form-control"
                  id="status"
                  :options="listStatusCustomer"
                  v-model="$v.usersForm.status.$model"
                  :isError="$v.usersForm.status.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div v-if="$v.usersForm.status.$invalid" class="invalid-feedback-custom">
                  User should be filled.
                </div>
              </div>
            </CCol>

            <CCol sm="3">
              <div class="form-group">
                <label for="user Group">User Group</label>
                <model-select
                  class="form-control"
                  id="user_group"
                  :options="listCustomerGroup"
                  v-model="$v.usersForm.user_group.$model"
                  :isError="$v.usersForm.user_group.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.usersForm.user_group.$invalid"
                  class="invalid-feedback-custom"
                >
                  User should be filled.
                </div>
              </div>
            </CCol>

            <CCol sm="3">
              <div class="form-group">
                <label for="user Type">User Type</label>
                <model-select
                  class="form-control"
                  id="user_type"
                  :options="listCustomerType"
                  v-model="$v.usersForm.user_type.$model"
                  :isError="$v.usersForm.user_type.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.usersForm.user_type.$invalid"
                  class="invalid-feedback-custom"
                >
                  User should be filled.
                </div>
              </div>
            </CCol>
          </CRow>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              title="Detail"
              size="sm"
              :disabled="$v.usersForm.$invalid"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Address</template>
            <Address
              :items.sync="listAddress"
              :iduser="idUser"
              :provinceList="provinceList"
            ></Address>
          </CTab>
          <CTab v-if="user_code !== null">
            <template slot="title">Document</template>
            <UserDocument
              :userDocument.sync="listUserDocument"
              :userCode="user_code"
            ></UserDocument>
          </CTab>
          <CTab v-if="user_code !== null">
            <template slot="title">Voucher</template>
            <UserVoucher
              :voucher.sync="listUserVoucher"
              :userCode="user_code"
            ></UserVoucher>
          </CTab>
          <CTab v-if="user_code !== null">
            <template slot="title">Password</template>
            <GeneratePassword :userCode="user_code"></GeneratePassword>
          </CTab>
          <CTab v-if="user_code !== null">
            <template slot="title">Comunity</template>
            <UserComunity
              :comunity.sync="listUserComunity"
              :userCode="user_code"
            ></UserComunity>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../templates/Loading";

import { required } from "vuelidate/lib/validators";
import Address from "./tabs/Address";
import UserDocument from "./tabs/UserDocument";
import UserVoucher from "./tabs/UserVoucher";
import GeneratePassword from "./tabs/GeneratePassword";
import UserComunity from "./tabs/UserComunity";

export default {
  name: "UserDetail",
  components: {
    GlobalTable,
    Loading,
    Address,
    UserDocument,
    UserVoucher,
    GeneratePassword,
    UserComunity,
  },
  data() {
    return {
      title: "User Detail",
      fields: [
        { key: "user_code", label: "User Code", sorter: true },
        { key: "name", label: "Nama User", sorter: true },
        { key: "email", label: "Email", sorter: true },
        { key: "mobilephone", label: "Handphone", sorter: true },
        { key: "address", label: "Alamat Utama", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      usersForm: tableInterfaces.users,
      listStatusCustomer: [],
      listCustomerGroup: [],
      listCustomerType: [],
      listAddress: [],
      listUserVoucher: [],
      listUserComunity: [],
      items: [],
      provinceList: [],
      listUserDocument: [],
      idUser: null,
      isLoading: false,
      isEdit: false,
      addButton: false,
      activeTab: 0,
    };
  },
  validations: {
    usersForm: {
      user_code: {},
      name: { required },
      email: { required },
      mobile_phone: { required },
      status: { required },
      uuid: {},
      date_inserted: {},
      points: {},
      user_group: { required },
      user_type: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    user_code: function () {
      return this.usersForm.user_code;
    },
  },
  methods: {
    init: function (id) {
      this.idUser = id;
      this.resetForm();
      this.getDropdown();
      // this.getDropdownGroup();
      // this.getDropdownType();
      this.getDetailUser(id);
      // this.getProvinceList();
    },
    back: function () {
      this.$router.go(-1);
    },
    getDetailUser: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/users/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.usersForm = response.data.data;
            this.listAddress = response.data.address;
            this.listUserDocument = response.data.document;
            this.listUserVoucher = response.data.user_voucher;
            this.listUserComunity = response.data.user_comunity;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getDropdown: function () {
      this.axios
        .get("console/dropdown/users")
        .then((response) => {
          this.listStatusCustomer = response.data.user_status;
          this.provinceList = response.data.province;
          this.listCustomerGroup = response.data.user_group;
          this.listCustomerType = response.data.user_type;
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah user ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/users/update", this.usersForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Konsumen Detail",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Konsumen Detail");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    resetForm: function () {
      for (var i in tableInterfaces.users) {
        tableInterfaces.users[i] = null;
      }
      this.usersForm = tableInterfaces.users;
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
</style>
